import * as React from "react";
const SvgFiRrRing = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 3C5.898 3 1.008 5.351.148 8.507A1 1 0 0 0 0 9v5.5C0 18.145 5.271 21 12 21s12-2.855 12-6.5v-5C24 5.855 18.729 3 12 3m0 2c5.894 0 10 2.372 10 4.5 0 .362-.127.73-.353 1.092C19.42 8.966 15.887 8 12 8c-3.867 0-7.438.971-9.655 2.579C2.125 10.221 2 9.857 2 9.5 2 7.372 6.106 5 12 5m8.18 6.994C18.433 13.14 15.544 14 12 14s-6.426-.858-8.174-2.002C5.712 10.767 8.753 10 12 10s6.283.753 8.18 1.994M12 19c-5.894 0-10-2.372-10-4.5v-1.362C4.132 14.876 7.779 16 12 16s7.868-1.124 10-2.862V14.5c0 2.128-4.106 4.5-10 4.5"
    />
  </svg>
);
export default SvgFiRrRing;
